import $ from 'jquery';
import { getState, modifyState } from '~src/state';

export const centerCanvas = () => {
  window.canvas.viewportTransform = [1, 0, 0, 1, 0, 0];
  window.canvas.setZoom(1);
  window.canvas.renderAll();

  const initialCanvasZoom = getState('initialCanvasZoom');

  $('#canvas-zoom').css({
    transform: `scale(${initialCanvasZoom})`,
    'margin-top': 0,
    'margin-left': 0,
  });
  $('#brush-canvas-container').css({
    transform: `scale(${initialCanvasZoom})`,
    'margin-top': 0,
    'margin-left': 0,
  });

  modifyState('currentCanvasZoom', initialCanvasZoom);
};
